
import moment from 'moment';

export interface EventData {
    start: string;
    end: string;
    title: string;
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
    classNames?: string[];
    extendedProps?: any;
}

export interface VendorInfo {
    vendorName: string;
    lockerNumber: number;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    allowStratEndTimeEachDay: boolean;
    allowEntireTimeBlock: boolean;
}

/**
 * Generates events based on vendor access rules
 * @param vendorInfo - Vendor information including dates, times, and access rules
 * @returns Array of events for the calendar
 */
export function generateVendorEvents(vendorInfo: VendorInfo): EventData[] {
    const events: EventData[] = [];

    const startDate = moment(vendorInfo.startDate, 'YYYY-MM-DD');
    const endDate = moment(vendorInfo.endDate, 'YYYY-MM-DD');
    const startTime = moment(vendorInfo.startTime, 'hh:mm A');
    const endTime = moment(vendorInfo.endTime, 'hh:mm A');

    if (vendorInfo.allowStratEndTimeEachDay) {
        // Create one event per day with same start/end times
        const currentDate = startDate.clone();

        while (currentDate.isSameOrBefore(endDate, 'day')) {
            const eventStart = currentDate.clone().hour(startTime.hour()).minute(startTime.minute()).second(0);

            const eventEnd = currentDate.clone().hour(endTime.hour()).minute(endTime.minute()).second(0);

            events.push({
                start: eventStart.format(),
                end: eventEnd.format(),
                title: `${vendorInfo.vendorName}`,
                backgroundColor: '#ffe0b2',
                borderColor: '#ff9800',
                textColor: '#000000',
                classNames: ['calendarTitle', 'vendor-event'],
                extendedProps: {
                    ...vendorInfo,
                    isVendor: true,
                    dayIndex: currentDate.diff(startDate, 'days') + 1,
                },
            });

            currentDate.add(1, 'day');
        }
    } else if (vendorInfo.allowEntireTimeBlock) {
        // Split into events covering entire days
        const currentDate = startDate.clone();

        while (currentDate.isSameOrBefore(endDate, 'day')) {
            let eventStart: moment.Moment;
            let eventEnd: moment.Moment;

            if (currentDate.isSame(startDate, 'day')) {
                // First day: from start time to 11:59 PM
                eventStart = currentDate.clone().hour(startTime.hour()).minute(startTime.minute()).second(0);
                eventEnd = currentDate.clone().hour(23).minute(59).second(59);
            } else if (currentDate.isSame(endDate, 'day')) {
                // Last day: from 12:00 AM to end time
                eventStart = currentDate.clone().hour(0).minute(0).second(0);
                eventEnd = currentDate.clone().hour(endTime.hour()).minute(endTime.minute()).second(0);
            } else {
                // Intermediate days: 12:00 AM - 11:59 PM
                eventStart = currentDate.clone().hour(0).minute(0).second(0);
                eventEnd = currentDate.clone().hour(23).minute(59).second(59);
            }

            events.push({
                start: eventStart.format(),
                end: eventEnd.format(),
                title: `${vendorInfo.vendorName}`,
                backgroundColor: '#ffe0b2',
                borderColor: '#ff9800',
                textColor: '#000000',
                classNames: ['calendarTitle', 'vendor-event'],
                extendedProps: {
                    ...vendorInfo,
                    isVendor: true,
                    dayIndex: currentDate.diff(startDate, 'days') + 1,
                },
            });

            currentDate.add(1, 'day');
        }
    }


    return events;
}
